import { defineMessages } from '../define';

export const settings = defineMessages(
  {
    'settings.title': 'Stillingar',
    // Profile
    'settings.profile': 'Prófíll',
    'settings.full_name': 'Fullt nafn',
    'settings.phone': 'Símanúmer',
    'settings.phone_hint': 'T.d. 899 1234',
    'settings.email_public': 'Netfang í félagatali',
    'settings.email_public_hint': 'Ef autt er innskráningarnetfangið ({email}) sýnt.',
    'settings.share_phone': 'Sýna símanúmer í félagatali',
    'settings.share_email': 'Sýna netfang í félagatali',
    'settings.share_hint': 'Aðeins innskráðir félagar sjá þetta. Kerfisstjórar kórsins sjá alltaf samskiptaupplýsingar.',
    'settings.share_needs_phone': 'Sláðu fyrst inn símanúmer.',
    'settings.section_role': 'Rödd og hlutverk',
    'settings.section_hint': 'Stjórnandi eða kerfisstjóri breytir rödd og hlutverki.',
    'settings.login_email': 'Innskráningarnetfang',
    'settings.profile_saved': 'Prófíllinn var vistaður',
    'settings.name_required': 'Sláðu inn nafnið þitt.',
    'settings.phone_invalid': 'Símanúmerið lítur ekki rétt út.',
    'settings.email_invalid': 'Netfangið lítur ekki rétt út.',
    'settings.unsaved': 'Óvistaðar breytingar',
    // Language
    'settings.language': 'Tungumál',
    'settings.lang_is': 'Íslenska',
    'settings.lang_en': 'English',
    'settings.lang_needs_online': 'Tengstu netinu til að breyta tungumáli.',
    // Password
    'settings.password': 'Lykilorð',
    'settings.password_desc': 'Þegar þú breytir lykilorðinu ertu skráður út af öðrum tækjum.',
    'settings.change_password': 'Breyta lykilorði',
    'settings.current_password': 'Núverandi lykilorð',
    'settings.new_password': 'Nýtt lykilorð',
    'settings.repeat_password': 'Endurtaktu nýja lykilorðið',
    'settings.password_rules': 'Að minnsta kosti {min} stafir. Gott ráð: nokkur orð saman, t.d. „sól tenór vetur kaffi“.',
    'settings.password_too_short': 'Lykilorðið þarf að vera að minnsta kosti {min} stafir.',
    'settings.password_too_common': 'Þetta lykilorð er of algengt. Veldu annað.',
    'settings.password_mismatch': 'Lykilorðin eru ekki eins.',
    'settings.password_same': 'Nýja lykilorðið má ekki vera það sama og það núverandi.',
    'settings.password_wrong': 'Núverandi lykilorð er rangt.',
    'settings.password_changed': 'Lykilorðinu var breytt',
    'settings.password_working': 'Augnablik…',
    'settings.show_passwords': 'Sýna lykilorð',
    // Drawing
    'settings.drawing': 'Teikning á nótur',
    'settings.draw_auto': 'Sjálfvirkt',
    'settings.draw_auto_desc': 'Fingurinn teiknar þar til Apple Pencil greinist á þessu tæki. Eftir það teiknar aðeins penninn og fingurinn flettir.',
    'settings.draw_finger': 'Fingur teiknar',
    'settings.draw_finger_desc': 'Fingurinn teiknar alltaf í skriftarham, líka þótt penni sé notaður.',
    'settings.draw_pen': 'Aðeins penni',
    'settings.draw_pen_desc': 'Aðeins Apple Pencil teiknar. Fingurinn flettir og stækkar.',
    'settings.draw_hint': 'Gildir aðeins á þessu tæki.',
    // Offline
    'settings.offline': 'Ónettengt',
    'settings.storage': 'Geymslurými og vistuð lög',
    'settings.storage_usage': '{used} notuð af {quota}',
    'settings.storage_unknown': 'Þetta tæki gefur ekki upp hve mikið geymslurými er notað.',
    'settings.storage_persisted': 'Gögnin eru varin gegn sjálfvirkri hreinsun vafrans.',
    'settings.storage_soon': 'Brátt geturðu vistað lög og lagalista hér fyrir notkun án nets.',
    // Install / privacy / version
    'settings.install': 'Setja á heimaskjá',
    'settings.install_desc': 'Leiðbeiningar til að setja appið á heimaskjá iPad eða síma.',
    'settings.installed': 'Appið er á heimaskjánum.',
    'settings.privacy': 'Persónuvernd',
    'settings.privacy_desc': 'Hvaða upplýsingar eru geymdar og hver sér þær.',
    'settings.version': 'Útgáfa',
    'settings.about': 'Um appið',
    // Logout
    'settings.account': 'Aðgangur',
    'settings.logout': 'Skrá út',
    'settings.logout_confirm': 'Skrá út af þessu tæki?',
    'settings.logout_body': 'Gögn sem vistuð eru á þessu tæki verða fjarlægð. Þú getur skráð þig aftur inn með netfangi og lykilorði.',
    'settings.logout_all': 'Skrá út af öllum tækjum',
    'settings.logout_all_confirm': 'Skrá út af öllum tækjum?',
    'settings.logout_all_body': 'Þú verður skráður út á öllum tækjum, líka þessu. Gott ef tæki hefur glatast.',
    'settings.logout_failed': 'Ekki tókst að skrá út. Athugaðu nettenginguna.',

    // Privacy policy (persónuverndarstefna)
    'settings.privacy.title': 'Persónuverndarstefna',
    'settings.privacy.updated': 'Síðast uppfært í október 2026',
    'settings.privacy.intro':
      'Karlakór Grafarvogs rekur þetta app fyrir félaga kórsins. Hér er lýst hvaða persónuupplýsingar eru unnar, í hvaða tilgangi og hverjir hafa aðgang að þeim, í samræmi við lög nr. 90/2018 um persónuvernd og vinnslu persónuupplýsinga og almennu persónuverndarreglugerðina (GDPR).',
    'settings.privacy.controller_h': 'Ábyrgðaraðili',
    'settings.privacy.controller':
      'Karlakór Grafarvogs er ábyrgðaraðili vinnslunnar. Stjórn kórsins svarar öllum fyrirspurnum um persónuvernd.',
    'settings.privacy.stored_h': 'Hvað er geymt',
    'settings.privacy.stored_1': 'Nafn, netfang til innskráningar, rödd og hlutverk í kórnum.',
    'settings.privacy.stored_2':
      'Ef þú velur: símanúmer, netfang fyrir félagatal og mynd. Ritstjóri (t.d. stjórnandi kórsins) eða kerfisstjóri getur líka sett inn mynd af þér með þínu samþykki. Meðan þú ert með aðgang getur þú alltaf skipt um hana eða fjarlægt hana í Stillingum; annars fjarlægir stjórn kórsins hana að beiðni þinni.',
    'settings.privacy.stored_3': 'Svör við viðburðum (kem / kem ekki), mæting og athugasemdir við svör.',
    'settings.privacy.stored_4': 'Skilaboð sem þú skrifar við viðburði og í spjalli kórsins eða raddarinnar þinnar.',
    'settings.privacy.stored_5': 'Merkingar og teikningar sem þú gerir á nótur.',
    'settings.privacy.stored_6': 'Tæknilegar upplýsingar: innskráningar (tegund vafra og síðasta notkun) og villuskráning.',
    'settings.privacy.password':
      'Lykilorðið þitt fer aldrei til okkar. Tækið þitt reiknar úr því lykil og netþjónninn geymir aðeins dulritaða útgáfu hans.',
    'settings.privacy.purpose_h': 'Tilgangur',
    'settings.privacy.purpose':
      'Upplýsingarnar eru eingöngu notaðar fyrir starf kórsins: að deila nótum og æfingaefni, skipuleggja æfingar og tónleika og halda utan um mætingu. Þær eru hvorki notaðar í markaðsskyni né seldar.',
    'settings.privacy.basis':
      'Vinnslan byggir á lögmætum hagsmunum kórsins af starfseminni. Valkvæðar upplýsingar (sími, netfang í félagatali og mynd) byggja á samþykki þínu, sem þú getur dregið til baka hvenær sem er í Stillingum.',
    'settings.privacy.who_h': 'Hverjir sjá upplýsingarnar',
    'settings.privacy.who_1': 'Aðeins innskráðir félagar kórsins – ekkert er opið almenningi.',
    'settings.privacy.who_2':
      'Félagar sjá nafn, rödd, titil og mynd hver annars. Símanúmer og netfang sjást aðeins ef þú velur að sýna þau.',
    'settings.privacy.who_3':
      'Stjórnandi og aðstoðarfólk hans sjá svör og mætingu til að skipuleggja starfið. Kórspjallið sjá allir félagar; raddspjall sjá félagar raddarinnar, stjórnandi kórsins og ritstjórar.',
    'settings.privacy.who_4': 'Kerfisstjórar kórsins sjá þær upplýsingar sem þarf til að reka appið, þar á meðal samskiptaupplýsingar.',
    'settings.privacy.who_5': 'Merkingar þínar á nótur sér enginn nema þú, nema þú deilir þeim sjálfur.',
    'settings.privacy.processors_h': 'Vinnsluaðilar og staðsetning gagna',
    'settings.privacy.processors':
      'Appið er hýst hjá Cloudflare, sem er vinnsluaðili kórsins. Gagnagrunnur og skrár eru vistuð innan Evrópusambandsins. Engir aðrir fá upplýsingarnar.',
    'settings.privacy.retention_h': 'Varðveisla',
    'settings.privacy.retention':
      'Upplýsingarnar eru geymdar meðan þú ert í kórnum. Þegar félagi hættir er aðgangi hans lokað. Að beiðni eru persónuupplýsingar gerðar nafnlausar: nafni og samskiptaupplýsingum er eytt ásamt mynd og einkamerkingum, skilaboð standa áfram undir „Fyrrverandi félagi“ og mæting nýtist aðeins í samanlagðri tölfræði. Öryggisafrit eru geymd í takmarkaðan tíma (að hámarki 90 daga).',
    'settings.privacy.device_h': 'Afrit á tækinu þínu',
    'settings.privacy.device':
      'Svo appið virki án nets geymir tækið þitt afrit af nótum, hljóðskrám, dagatali og félagatali sem þú hefur aðgang að. Þau eru fjarlægð þegar þú skráir þig út. Afrit á tæki sem kemst aldrei aftur á netið er ekki hægt að fjarlægja úr fjarlægð.',
    'settings.privacy.calendar_h': 'Dagatalsáskrift',
    'settings.privacy.calendar':
      'Ef þú tengir dagatal kórsins við t.d. Apple- eða Google-dagatal fá þau fyrirtæki upplýsingar um viðburðina (heiti, tíma, staðsetningu og þitt svar). Þú getur endurnýjað slóðina hvenær sem er til að loka eldri áskrift.',
    'settings.privacy.cookies_h': 'Vafrakökur',
    'settings.privacy.cookies': 'Appið notar eina nauðsynlega vafraköku til að halda þér innskráðum. Engar auglýsinga- eða rakningarkökur eru notaðar.',
    'settings.privacy.rights_h': 'Réttindi þín',
    'settings.privacy.rights':
      'Þú átt rétt á að fá aðgang að upplýsingum um þig, fá þær leiðréttar eða þeim eytt og að andmæla vinnslu. Hafðu samband við stjórn kórsins til að fá afrit af gögnunum þínum eða láta eyða þeim. Þú getur einnig kvartað til Persónuverndar (personuvernd.is).',
  },
  {
    'settings.title': 'Settings',
    // Profile
    'settings.profile': 'Profile',
    'settings.full_name': 'Full name',
    'settings.phone': 'Phone number',
    'settings.phone_hint': 'E.g. 899 1234',
    'settings.email_public': 'E-mail shown in the directory',
    'settings.email_public_hint': 'If empty, your login e-mail ({email}) is shown.',
    'settings.share_phone': 'Show phone number in the directory',
    'settings.share_email': 'Show e-mail in the directory',
    'settings.share_hint': 'Only signed-in members can see this. Choir administrators always see contact details.',
    'settings.share_needs_phone': 'Enter a phone number first.',
    'settings.section_role': 'Section and role',
    'settings.section_hint': 'The conductor or an administrator changes your section and role.',
    'settings.login_email': 'Login e-mail',
    'settings.profile_saved': 'Profile saved',
    'settings.name_required': 'Please enter your name.',
    'settings.phone_invalid': 'The phone number does not look right.',
    'settings.email_invalid': 'The e-mail address does not look right.',
    'settings.unsaved': 'Unsaved changes',
    // Language
    'settings.language': 'Language',
    'settings.lang_is': 'Íslenska',
    'settings.lang_en': 'English',
    'settings.lang_needs_online': 'Connect to the internet to change the language.',
    // Password
    'settings.password': 'Password',
    'settings.password_desc': 'Changing your password signs you out on your other devices.',
    'settings.change_password': 'Change password',
    'settings.current_password': 'Current password',
    'settings.new_password': 'New password',
    'settings.repeat_password': 'Repeat the new password',
    'settings.password_rules': 'At least {min} characters. Tip: a few words together, e.g. “sun tenor winter coffee”.',
    'settings.password_too_short': 'The password must be at least {min} characters.',
    'settings.password_too_common': 'This password is too common. Choose another one.',
    'settings.password_mismatch': 'The passwords do not match.',
    'settings.password_same': 'The new password must differ from the current one.',
    'settings.password_wrong': 'The current password is wrong.',
    'settings.password_changed': 'Password changed',
    'settings.password_working': 'One moment…',
    'settings.show_passwords': 'Show passwords',
    // Drawing
    'settings.drawing': 'Drawing on sheets',
    'settings.draw_auto': 'Automatic',
    'settings.draw_auto_desc': 'Your finger draws until an Apple Pencil is detected on this device. After that only the pencil draws and your finger scrolls.',
    'settings.draw_finger': 'Finger draws',
    'settings.draw_finger_desc': 'Your finger always draws in edit mode, even if a pencil is used.',
    'settings.draw_pen': 'Pencil only',
    'settings.draw_pen_desc': 'Only the Apple Pencil draws. Your finger scrolls and zooms.',
    'settings.draw_hint': 'Applies to this device only.',
    // Offline
    'settings.offline': 'Offline',
    'settings.storage': 'Storage and saved songs',
    'settings.storage_usage': '{used} used of {quota}',
    'settings.storage_unknown': 'This device does not report how much storage is used.',
    'settings.storage_persisted': 'Data is protected from automatic browser clean-up.',
    'settings.storage_soon': 'Soon you will be able to save songs and setlists here for offline use.',
    // Install / privacy / version
    'settings.install': 'Add to Home Screen',
    'settings.install_desc': 'How to add the app to the Home Screen of your iPad or phone.',
    'settings.installed': 'The app is on your Home Screen.',
    'settings.privacy': 'Privacy',
    'settings.privacy_desc': 'What is stored and who can see it.',
    'settings.version': 'Version',
    'settings.about': 'About',
    // Logout
    'settings.account': 'Account',
    'settings.logout': 'Sign out',
    'settings.logout_confirm': 'Sign out on this device?',
    'settings.logout_body': 'Data saved on this device will be removed. You can sign in again with your e-mail and password.',
    'settings.logout_all': 'Sign out on all devices',
    'settings.logout_all_confirm': 'Sign out on all devices?',
    'settings.logout_all_body': 'You will be signed out on every device, including this one. Useful if a device was lost.',
    'settings.logout_failed': 'Could not sign out. Check your connection.',

    // Privacy policy
    'settings.privacy.title': 'Privacy policy',
    'settings.privacy.updated': 'Last updated October 2026',
    'settings.privacy.intro':
      'Karlakór Grafarvogs runs this app for the members of the choir. This page describes which personal data is processed, for what purpose and who has access to it, in accordance with the Icelandic Data Protection Act no. 90/2018 and the General Data Protection Regulation (GDPR).',
    'settings.privacy.controller_h': 'Controller',
    'settings.privacy.controller': 'Karlakór Grafarvogs is the data controller. The choir board answers all privacy questions.',
    'settings.privacy.stored_h': 'What is stored',
    'settings.privacy.stored_1': 'Name, login e-mail, section and role in the choir.',
    'settings.privacy.stored_2':
      'If you choose: phone number, directory e-mail and photo. An editor (e.g. the conductor) or an administrator can also add a photo of you with your consent. While you have access you can always replace or remove it in Settings; otherwise the choir board removes it on request.',
    'settings.privacy.stored_3': 'Event replies (coming / not coming), attendance and notes on replies.',
    'settings.privacy.stored_4': 'Messages you write on events and in the choir’s or your section’s chat.',
    'settings.privacy.stored_5': 'Annotations and drawings you make on sheet music.',
    'settings.privacy.stored_6': 'Technical data: sign-in sessions (browser type and last use) and error logs.',
    'settings.privacy.password':
      'Your password is never sent to us. Your device derives a key from it and the server only stores a cryptographically protected version of that key.',
    'settings.privacy.purpose_h': 'Purpose',
    'settings.privacy.purpose':
      'The data is used only for the work of the choir: sharing sheet music and practice material, organising practices and concerts and keeping track of attendance. It is never used for marketing or sold.',
    'settings.privacy.basis':
      'Processing is based on the legitimate interests of the choir. Optional data (phone, directory e-mail and photo) is based on your consent, which you can withdraw at any time in Settings.',
    'settings.privacy.who_h': 'Who can see the data',
    'settings.privacy.who_1': 'Only signed-in members of the choir – nothing is public.',
    'settings.privacy.who_2': 'Members see each other’s name, section, title and photo. Phone and e-mail are only visible if you choose to show them.',
    'settings.privacy.who_3':
      'The conductor and assistants see replies and attendance to plan rehearsals. Every member sees the choir chat; a section chat is seen by that section, the conductor and editors.',
    'settings.privacy.who_4': 'Choir administrators see the data needed to run the app, including contact details.',
    'settings.privacy.who_5': 'Nobody but you sees your annotations, unless you share them yourself.',
    'settings.privacy.processors_h': 'Processors and data location',
    'settings.privacy.processors':
      'The app is hosted by Cloudflare, which acts as the choir’s processor. The database and files are stored within the European Union. Nobody else receives the data.',
    'settings.privacy.retention_h': 'Retention',
    'settings.privacy.retention':
      'Data is kept while you are a member. When a member leaves, their access is closed. On request, personal data is anonymised: name and contact details are deleted together with the photo and private annotations, messages remain under “Former member” and attendance is only used in aggregate statistics. Backups are kept for a limited time (at most 90 days).',
    'settings.privacy.device_h': 'Copies on your device',
    'settings.privacy.device':
      'So the app works offline, your device keeps copies of the sheets, audio, calendar and directory you have access to. They are removed when you sign out. Copies on a device that never comes back online cannot be removed remotely.',
    'settings.privacy.calendar_h': 'Calendar subscription',
    'settings.privacy.calendar':
      'If you subscribe to the choir calendar in e.g. Apple or Google Calendar, those companies receive the event data (title, time, location and your reply). You can renew the address at any time to stop an old subscription.',
    'settings.privacy.cookies_h': 'Cookies',
    'settings.privacy.cookies': 'The app uses a single essential cookie to keep you signed in. No advertising or tracking cookies are used.',
    'settings.privacy.rights_h': 'Your rights',
    'settings.privacy.rights':
      'You have the right to access your data, have it corrected or erased, and to object to processing. Contact the choir board to get a copy of your data or have it erased. You can also complain to the Icelandic Data Protection Authority (personuvernd.is).',
  },
);
